import type { CaptureModulePack } from '../types';
import { CameraPage } from '../../../pages/CameraPage';
import { ResultPage } from '../../../pages/ResultPage';
import { countdown, manifest } from './manifest';

export const GCamDefaultModule: CaptureModulePack = {
  ...manifest,
  CaptureView: CameraPage,
  ResultView: ResultPage,
  countdown,
};
